require('./client/zingchart.min.js');
zingchart.MODULESDIR = "https://cdn.zingchart.com/2.6.3/modules/";
module.exports = zingchart;



//////////////////
// WEBPACK FOOTER
// ./~/zingchart/index.js
// module id = 1203
// module chunks = 1